import { atom } from 'recoil';

export const addToTrackingBoardUtilityStateAtom = atom({
  key: 'addToTrackingBoardUtilityStateAtom',
  default: {
    open: false,
  },
});
